// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2YCK6","bigColWidth":"Table_bigColWidth__2NdAp","biggerColWidth":"Table_biggerColWidth__2eOyn","row":"Table_row__1hfjg","col":"Table_col__3ZvH3"};